import Sketch from './app';

new Sketch({
    dom: document.getElementById("container"),
    px: 5.82, py: -2.3, pz: -0.32, tx: -1.64, ty: 0.84, tz: 0.32
});

gsap.to('.char', {
    y: 0,
    stagger: 0.05,
    delay: 0.2,
    duration: .1
})